import AuthLayout from '@components/v2/layout/AuthLayout/AuthLayout';
import { ReactNode } from 'react';
import { useAuthContext } from '../AuthContext';
import AuthContactButton from './AuthContactButton/AuthContactButton';

interface AuthShellProps {
  children: ReactNode;
}

const AuthShell = ({ children }: AuthShellProps) => {
  const { loginContext } = useAuthContext();

  return (
    <AuthLayout
      imageUrl={loginContext?.loginImageUrl ?? undefined}
      slots={{ footer: <AuthContactButton /> }}
    >
      {children}
    </AuthLayout>
  );
};

export default AuthShell;
